import React, { createContext, useState } from "react";

const AppContext = createContext(); // Create context

const AppProvider = ({ children }) => {
  const [state, setState] = useState({
    sanckBar: {
      type: null,
      message: "",
    },
  });

  return (
    <AppContext.Provider value={{ state, setState }}>
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppProvider };
